/**
 * @description 登录失效处理
 */
import Vue from 'vue'
import store from '../store'
import router from '../router'
import config from '../config/'

export default function sessionExpectionFilter(response) {
  const {data} = response
  if (response.status === 403) {
    Vue.$toast('活动太火爆，请稍后再试')
  }
  if ((data.errorCode && (data.errorCode === '600' || data.errorCode === '6000' || data.errorCode === '21' || data.errorCode === '410002' || data.errorCode === '410001' || data.errorCode === '3100' )) || (data.message && data.message === 'SESSION_EXPIRES')) {
    Vue.$toast('登录过期，请稍后再试')
    store.dispatch('updateUserInfo', {data: {token: ''}})
    if (store.state.client.client.env === 'wx') {
      if (config.wxUrl) {
        store.dispatch('authentication')
      } else if (config.indexUrl) {
        window.location.href = config.indexUrl
      } else {
        return { ...response, ...{data: 'h5loginExpired'}} // 微信环境下登录失效也返回失效的错误
      }
    } else if (store.state.client.client.env === 'wxMini') { // 微信小程序
      store.dispatch('wxMiniOverdue')
    } else if (config.indexUrl) {
      window.location.href = config.indexUrl
      // return { ...response, ...{data: 'h5loginExpired'}}
    } else {
      router.replace({name: 'index'})
    }
  } else {
    return response
  }
}
